import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import PrivacyPolicyLink from '@sputnik/components/PrivacyPolicyLink'
import TermsAndConditionsLink from '@sputnik/components/TermsAndConditionsLink'
import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import styles from './styles.module.scss'

const BillTermsAndConditionsPrompt = () => {
  const [getClassName] = useNameFormatter('BillTermsAndConditionsPrompt')
  const { BILL_SPEND_AND_EXPENSE } = PRODUCT_CONST_STRINGS
  const { track } = useWebTracking()

  return (
    <div className={`${styles[getClassName('')]} dd-privacy-allow`}>
      <FormattedMessage
        defaultMessage='By continuing, you agree to {BILL_SPEND_AND_EXPENSE}’s <termsLink>Terms & Conditions</termsLink> and <privacyLink>Privacy Policy</privacyLink>.'
        id='sputnik.BillTermsAndConditionsPrompt__SOGRBL'
        values={{
          BILL_SPEND_AND_EXPENSE,
          privacyLink: (text) => (
            <PrivacyPolicyLink
              alternateLinkString={text}
              onClick={() => track('se_signup__privacy_policy__fired')}
            />
          ),
          termsLink: (text) => (
            <TermsAndConditionsLink
              alternateLinkString={text}
              onClick={() => track('se_signup__terms_and_conditions__fired')}
            />
          ),
        }}
      />
    </div>
  )
}

export default BillTermsAndConditionsPrompt
